import { cancelComputerUseRun } from '@/features/rpa/agent-client/cancel-computer-use-run';
import { useExecutorStopSignal } from '@/features/rpa/executor/useExecutorStopSignal';
import { agentHarnessClient, streamHeaders } from '@heidi/agents';
import {
  useProjectDesktopDelegation as useProjectDesktopDelegationCore,
  type ProjectDesktopDelegationPorts,
} from '@heidi/agents/data';

// The rpa executor's stop and its app-wide stop signal, and the run transport the
// child's progress streams over. Module-level, so the hook port keeps one identity.
const DESKTOP_DELEGATION_PORTS: ProjectDesktopDelegationPorts = {
  cancelComputerUseRun,
  useIsExecutorStopSignalled: useExecutorStopSignal,
  transport: agentHarnessClient,
  streamHeaders,
};

/** The Work chat's desktop delegation, bound to the rpa executor. */
export const useProjectDesktopDelegation = (
  args: Omit<Parameters<typeof useProjectDesktopDelegationCore>[0], 'ports'>
): ReturnType<typeof useProjectDesktopDelegationCore> =>
  useProjectDesktopDelegationCore({ ...args, ports: DESKTOP_DELEGATION_PORTS });
